import Member from './Member'
import { Container, LabelRow, SubTitle } from './styles'

export default function TopMembersList ({ members = [] }) {
  return members?.length > 0 && ( 
    <Container>
      <LabelRow>
        <SubTitle style={{justifySelf: 'flex-start'}}>Nome</SubTitle>
        <SubTitle>Agendamentos realizados</SubTitle>
        <SubTitle style={{justifySelf: 'flex-end'}}>Gasto total</SubTitle>
      </LabelRow>
      {members.map ((member, index) => (
        <Member key={index} data={member}/>
      ))}
    </Container>
  )
}
